import React, { useRef, useState } from 'react';
import config from '/config/default.json';
// styles

import styles from './contact-us-form.module.scss';

// components
import HStack from 'avena-components/hstack';
import Button from "avena-components/button";
import Col from 'avena-components/col';
import Row from 'avena-components/row';
import Input from 'avena-components/input';
import TextArea from 'avena-components/text-area';

import { createContact } from "helpers/requests/contact";
import Spacer from 'avena-components/spacer';

const ContactUsForm = ({ id = 'contact-us' }) => {
    const captchaRef = useRef();
    const [ReCAPTCHA, setReCAPTCHA] = useState(null);

    const [form, setForm] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        message: '',
        captcha: null,
    });

    const valid = form.name && form.email && form.message && form.captcha;

    const handleInputChange = async (data) => {
        if (ReCAPTCHA === null) {
            setReCAPTCHA((await import('react-google-recaptcha')).default);
        }
        const { name, value } = data;
        setForm(prevState => ({ ...prevState, [`${name}`]: value }));
    };

    const handleClick = async () => {
        captchaRef.current.reset();
        const isSuccess = await createContact(form);
        isSuccess && setForm({
            name: '',
            email: '',
            company: '',
            phone: '',
            message: '',
            captcha: null
        });
    }

    return (
        <Row id={id} className={styles.contactUsForm}>
            <Col className={styles.leftColumn} xs={24} sm={24} md={24} lg={9} xl={9} >
                <div className={styles.header}>Contact Us</div>
                <div className={styles.sub_header}>Get in Touch With Us</div>
            </Col>
            <Col className={styles.rightColumn} xs={24} sm={24} md={24} lg={15} xl={15} >
                <Row >
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className={styles.inputContainer}>
                        <Input className={styles.input} label='Name *' value={form.name} name='name' onChange={handleInputChange} />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className={styles.inputContainer}>
                        <Input className={styles.input} label='E-mail *' value={form.email} name='email' onChange={handleInputChange} />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className={styles.inputContainer}>
                        <Input className={styles.input} label='Phone' value={form.phone} name='phone' onChange={handleInputChange} />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className={styles.inputContainer}>
                        <Input className={styles.input} label='Company' value={form.company} name='company' onChange={handleInputChange} />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className={styles.inputContainer}>
                        <TextArea className={styles.input} label='Message *' value={form.message} name='message' onChange={handleInputChange} />
                    </Col>
                </Row>
                <HStack className={styles.kvkk}>
                    {ReCAPTCHA &&
                        <ReCAPTCHA
                            ref={captchaRef}
                            sitekey={config.app.captcha.siteKey}
                            onChange={(e) => handleInputChange({ name: 'captcha', value: e })} />
                    }
                    <Spacer />
                    <Button disabled={!valid} onClick={handleClick} className={styles.button}>Send</Button>
                </HStack>
            </Col>
        </Row>
    )
}

export default ContactUsForm;